import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Label } from './styles.js'

const Button = ({
  primary,
  orange,
  ghost,
  ghostWhite,
  smallPaddings,
  onClick,
  mobile,
  children,
}) => {
  const handleClick = () => {
    onClick && onClick()
  }

  return (
    <Wrapper
      primary={primary}
      orange={orange}
      ghost={ghost}
      ghostWhite={ghostWhite}
      smallPaddings={smallPaddings}
      onClick={() => handleClick()}
    >
      {mobile !== '' ? (
        <Label>
          <span>{mobile}</span>
          <span>{children}</span>
        </Label>
      ) : (
        <Label>{children}</Label>
      )}
    </Wrapper>
  )
}

Button.propTypes = {
  primary: PropTypes.bool,
  orange: PropTypes.bool,
  ghost: PropTypes.bool,
  ghostWhite: PropTypes.bool,
  smallPaddings: PropTypes.bool,
  onClick: PropTypes.func,
  mobile: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

Button.defaultProps = {
  primary: false,
  orange: false,
  ghost: false,
  ghostWhite: false,
  smallPaddings: false,
  mobile: '',
  children: null,
}

export default Button
